// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewsBlock_root__TW515 {
  padding: 40px 0;
}
.NewsBlock_root__TW515 .NewsBlock_loadingBlock__APThM {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
.NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 173px);
  padding: 40px 0;
}
.NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_titleLinkBlock__su3EZ p {
  font-size: 26px;
  font-weight: bold;
  color: #00377c;
}
.NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_titleLinkBlock__su3EZ a {
  padding: 4px 10px;
  font-weight: bold;
  color: #d71921;
  border: 1px solid #d71921;
  border-radius: 20px;
  transition: 0.1s;
}
.NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_titleLinkBlock__su3EZ a:hover {
  color: #fff;
  background: #d71921;
}
.NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe {
  margin-top: 0;
}
.NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe > * {
  margin-top: 40px;
}
.NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe .NewsBlock_col__ixTW0 .NewsBlock_card__-tegX {
  height: 100%;
  --bs-card-border-width: none;
  --bs-card-border-radius: 20px;
}
.NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe .NewsBlock_col__ixTW0 .NewsBlock_card__-tegX .NewsBlock_cardBody__AkEu6 {
  padding: 0;
  color: #fff;
  background: #00377c;
  border-radius: 20px;
}
.NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe .NewsBlock_col__ixTW0 .NewsBlock_card__-tegX .NewsBlock_cardBody__AkEu6 .NewsBlock_imageBlock__eUn8t img {
  width: 100%;
  object-fit: cover;
  border-radius: 20px;
}
.NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe .NewsBlock_col__ixTW0 .NewsBlock_card__-tegX .NewsBlock_cardBody__AkEu6 .NewsBlock_titleInfoBlock__PhGyy {
  padding: 20px;
}
.NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe .NewsBlock_col__ixTW0 .NewsBlock_card__-tegX .NewsBlock_cardBody__AkEu6 .NewsBlock_titleInfoBlock__PhGyy .NewsBlock_titleBlock__tSTO9 {
  font-size: 20px;
  font-weight: bold;
}
.NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe .NewsBlock_col__ixTW0 .NewsBlock_card__-tegX .NewsBlock_cardBody__AkEu6 .NewsBlock_titleInfoBlock__PhGyy .NewsBlock_infoBlock__pg9YA {
  margin-top: 10px;
}
.NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe .NewsBlock_col__ixTW0 .NewsBlock_card__-tegX .NewsBlock_cardBody__AkEu6 .NewsBlock_titleInfoBlock__PhGyy .NewsBlock_infoBlock__pg9YA p {
  height: 6rem;
  overflow: hidden;
}
.NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe .NewsBlock_col__ixTW0 .NewsBlock_card__-tegX .NewsBlock_cardBody__AkEu6 .NewsBlock_titleInfoBlock__PhGyy .NewsBlock_linkBlock__w307r {
  margin-top: 10px;
}
.NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe .NewsBlock_col__ixTW0 .NewsBlock_card__-tegX .NewsBlock_cardBody__AkEu6 .NewsBlock_titleInfoBlock__PhGyy .NewsBlock_linkBlock__w307r a {
  font-size: 20px;
  text-decoration: underline;
  color: #fff;
}

@media (max-width: 991px) {
  .NewsBlock_root__TW515 {
    padding: 40px 0 0 0;
  }
  .NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe {
    flex-direction: column;
  }
  .NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe .NewsBlock_col__ixTW0 {
    width: 100%;
  }
}
@media (max-width: 768px) {
  .NewsBlock_root__TW515 {
    padding: 20px 0 0 0;
  }
  .NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU {
    padding: 20px 0;
  }
  .NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_titleLinkBlock__su3EZ p {
    font-size: 18px;
  }
  .NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_titleLinkBlock__su3EZ a {
    padding: 2px 8px;
    font-size: 14px;
  }
  .NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe {
    margin-top: 0;
  }
  .NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe .NewsBlock_col__ixTW0 .NewsBlock_card__-tegX .NewsBlock_cardBody__AkEu6 .NewsBlock_titleInfoBlock__PhGyy {
    padding: 15px;
  }
  .NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe .NewsBlock_col__ixTW0 .NewsBlock_card__-tegX .NewsBlock_cardBody__AkEu6 .NewsBlock_titleInfoBlock__PhGyy .NewsBlock_titleBlock__tSTO9 {
    font-size: 18px;
  }
  .NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe .NewsBlock_col__ixTW0 .NewsBlock_card__-tegX .NewsBlock_cardBody__AkEu6 .NewsBlock_titleInfoBlock__PhGyy .NewsBlock_infoBlock__pg9YA {
    margin-top: 10px;
    font-size: 14px;
  }
  .NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe .NewsBlock_col__ixTW0 .NewsBlock_card__-tegX .NewsBlock_cardBody__AkEu6 .NewsBlock_titleInfoBlock__PhGyy .NewsBlock_linkBlock__w307r a {
    font-size: 18px;
  }
}
@media (max-width: 500px) {
  .NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_titleLinkBlock__su3EZ p {
    font-size: 16px;
  }
  .NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_titleLinkBlock__su3EZ a {
    font-size: 12px;
  }
  .NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe .NewsBlock_col__ixTW0 .NewsBlock_card__-tegX .NewsBlock_cardBody__AkEu6 .NewsBlock_titleInfoBlock__PhGyy .NewsBlock_titleBlock__tSTO9 {
    font-size: 16px;
  }
  .NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe .NewsBlock_col__ixTW0 .NewsBlock_card__-tegX .NewsBlock_cardBody__AkEu6 .NewsBlock_titleInfoBlock__PhGyy .NewsBlock_infoBlock__pg9YA {
    font-size: 12px;
  }
  .NewsBlock_root__TW515 .NewsBlock_wrapper__T11HU .NewsBlock_row__nsPMe .NewsBlock_col__ixTW0 .NewsBlock_card__-tegX .NewsBlock_cardBody__AkEu6 .NewsBlock_titleInfoBlock__PhGyy .NewsBlock_linkBlock__w307r a {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NewsBlock/NewsBlock.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AACE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;AACJ;AAEE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;AAAJ;AAGM;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AADR;AAIM;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAFR;AAIQ;EACE,WAAA;EACA,mBAAA;AAFV;AAOI;EACE,aAAA;AALN;AAOM;EACE,gBAAA;AALR;AASQ;EACE,YAAA;EACA,4BAAA;EACA,6BAAA;AAPV;AASU;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AAPZ;AAUc;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;AARhB;AAYY;EACE,aAAA;AAVd;AAYc;EACE,eAAA;EACA,iBAAA;AAVhB;AAac;EACE,gBAAA;AAXhB;AAagB;EACE,YAAA;EACA,gBAAA;AAXlB;AAec;EACE,gBAAA;AAbhB;AAegB;EACE,eAAA;EACA,0BAAA;EACA,WAAA;AAblB;;AAwBA;EACE;IACE,mBAAA;EArBF;EAwBI;IACE,sBAAA;EAtBN;EAwBM;IACE,WAAA;EAtBR;AACF;AA4BA;EACE;IACE,mBAAA;EA1BF;EA4BE;IACE,eAAA;EA1BJ;EA6BM;IACE,eAAA;EA3BR;EA8BM;IACE,gBAAA;IACA,eAAA;EA5BR;EAgCI;IACE,aAAA;EA9BN;EAmCY;IACE,aAAA;EAjCd;EAmCc;IACE,eAAA;EAjChB;EAoCc;IACE,gBAAA;IACA,eAAA;EAlChB;EAsCgB;IACE,eAAA;EApClB;AACF;AA+CA;EAIQ;IACE,eAAA;EAhDR;EAmDM;IACE,eAAA;EAjDR;EA0Dc;IACE,eAAA;EAxDhB;EA2Dc;IACE,eAAA;EAzDhB;EA6DgB;IACE,eAAA;EA3DlB;AACF","sourcesContent":[".root {\n  padding: 40px 0;\n\n  .loadingBlock {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin-right: -50%;\n    transform: translate(-50%, -50%);\n  }\n\n  .wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: calc(100vh - 173px);\n    padding: 40px 0;\n\n    .titleLinkBlock {\n      p {\n        font-size: 26px;\n        font-weight: bold;\n        color: #00377c;\n      }\n\n      a {\n        padding: 4px 10px;\n        font-weight: bold;\n        color: #d71921;\n        border: 1px solid #d71921;\n        border-radius: 20px;\n        transition: 0.1s;\n\n        &:hover {\n          color: #fff;\n          background: #d71921;\n        }\n      }\n    }\n\n    .row {\n      margin-top: 0;\n\n      & > * {\n        margin-top: 40px;\n      }\n\n      .col {\n        .card {\n          height: 100%;\n          --bs-card-border-width: none;\n          --bs-card-border-radius: 20px;\n\n          .cardBody {\n            padding: 0;\n            color: #fff;\n            background: #00377c;\n            border-radius: 20px;\n\n            .imageBlock {\n              img {\n                width: 100%;\n                object-fit: cover;\n                border-radius: 20px;\n              }\n            }\n\n            .titleInfoBlock {\n              padding: 20px;\n\n              .titleBlock {\n                font-size: 20px;\n                font-weight: bold;\n              }\n\n              .infoBlock {\n                margin-top: 10px;\n\n                p {\n                  height: 6rem;\n                  overflow: hidden;\n                }\n              }\n\n              .linkBlock {\n                margin-top: 10px;\n\n                a {\n                  font-size: 20px;\n                  text-decoration: underline;\n                  color: #fff;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 991px) {\n  .root {\n    padding: 40px 0 0 0;\n\n    .wrapper {\n      .row {\n        flex-direction: column;\n\n        .col {\n          width: 100%;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .root {\n    padding: 20px 0 0 0;\n\n    .wrapper {\n      padding: 20px 0;\n\n      .titleLinkBlock {\n        p {\n          font-size: 18px;\n        }\n\n        a {\n          padding: 2px 8px;\n          font-size: 14px;\n        }\n      }\n\n      .row {\n        margin-top: 0;\n\n        .col {\n          .card {\n            .cardBody {\n              .titleInfoBlock {\n                padding: 15px;\n\n                .titleBlock {\n                  font-size: 18px;\n                }\n\n                .infoBlock {\n                  margin-top: 10px;\n                  font-size: 14px;\n                }\n\n                .linkBlock {\n                  a {\n                    font-size: 18px;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 500px) {\n  .root {\n    .wrapper {\n      .titleLinkBlock {\n        p {\n          font-size: 16px;\n        }\n\n        a {\n          font-size: 12px;\n        }\n      }\n\n      .row {\n        .col {\n          .card {\n            .cardBody {\n              .titleInfoBlock {\n                .titleBlock {\n                  font-size: 16px;\n                }\n\n                .infoBlock {\n                  font-size: 12px;\n                }\n\n                .linkBlock {\n                  a {\n                    font-size: 16px;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `NewsBlock_root__TW515`,
	"loadingBlock": `NewsBlock_loadingBlock__APThM`,
	"wrapper": `NewsBlock_wrapper__T11HU`,
	"titleLinkBlock": `NewsBlock_titleLinkBlock__su3EZ`,
	"row": `NewsBlock_row__nsPMe`,
	"col": `NewsBlock_col__ixTW0`,
	"card": `NewsBlock_card__-tegX`,
	"cardBody": `NewsBlock_cardBody__AkEu6`,
	"imageBlock": `NewsBlock_imageBlock__eUn8t`,
	"titleInfoBlock": `NewsBlock_titleInfoBlock__PhGyy`,
	"titleBlock": `NewsBlock_titleBlock__tSTO9`,
	"infoBlock": `NewsBlock_infoBlock__pg9YA`,
	"linkBlock": `NewsBlock_linkBlock__w307r`
};
export default ___CSS_LOADER_EXPORT___;
